import React from "react";
import { ArrowDown } from "lucide-react";
import heroBanner from "../assets/hero-banner.png";

const STATS = [
  { value: "2", label: "měsíce na realizaci" },
  { value: "100 %", label: "vše na klíč" },
];

const Hero = () => {
  return (
    <section className="relative bg-white pt-[80px] md:pt-[88px] pb-8 md:pb-10 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-[#efe1cc]/50 blur-3xl -z-10" />
      <div className="absolute top-40 -left-24 w-[360px] h-[360px] rounded-full bg-[#e6ecf3]/70 blur-3xl -z-10" />

      <div className="w-full">
        {/* Original banner - full width */}
        <div className="w-full overflow-hidden bg-white">
          <img
            src={heroBanner}
            alt="Aventa Reality – Rekonstrukce, která dává smysl. Byt 3+kk o velikosti 53 m²"
            className="w-full h-auto object-cover"
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Copy + CTA */}
        <div className="mt-10 md:mt-12 max-w-3xl mx-auto text-center">
          <p className="text-[16px] md:text-[18px] leading-relaxed text-[#4b5568]">
            Kompletní rekonstrukce bytů a domů na klíč – od rozvodů vody a
            elektřiny přes podlahy a omítky až po koupelny, kuchyně a změny
            dispozic. S vlastním týmem návrhářů.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <a
              href="#kontakt"
              className="font-serif-nav inline-flex items-center gap-2 bg-[#c79a5b] hover:bg-[#b3854a] text-[#1b2b45] text-[16px] font-bold uppercase tracking-[0.08em] px-9 py-4 rounded-none transition-colors"
            >
              Nezávazná poptávka
            </a>
            <a
              href="#sluzby"
              className="font-serif-nav group inline-flex items-center gap-2 text-[16px] font-bold uppercase tracking-[0.08em] text-[#1b2b45] px-8 py-4 rounded-none border border-[#1b2b45]/25 hover:border-[#1b2b45] transition-colors"
            >
              Naše služby
              <ArrowDown size={17} className="group-hover:translate-y-0.5 transition-transform" />
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-14 md:mt-16 border-t border-b border-[#e4ddd0] py-10">
          <div className="grid grid-cols-2 gap-8 max-w-3xl mx-auto">
            {STATS.map((s) => (
              <div key={s.label} className="text-center">
                <p className="font-heading text-[54px] md:text-[64px] font-bold text-[#c79a5b] leading-none">
                  {s.value}
                </p>
                <p className="text-[13px] md:text-[14px] text-[#6b7385] mt-3">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
